var render = function render(){var _vm=this,_c=_vm._self._c;return _c('print-container',[_c('div',{staticClass:"text-center title mt-7 mb-0"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-center subtitle-1 px-3 pb-6 my-0"},[_vm._v(_vm._s(_vm.subtitle))]),_c('tabelle',{class:[{'mb-8': _vm.$vuetify.breakpoint.smAndDown},
                 {'mb-4': _vm.$vuetify.breakpoint.mdAndUp}],attrs:{"saison":_vm.saison,"hide-legend":true,"dense":true,"is-print":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }